"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackEvent = void 0;
var API_URL = "https://api.logspot.io";
var trackEvent = function (config, payload) { return __awaiter(void 0, void 0, void 0, function () {
    var payloadToSend, err_1;
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (!payload.event) {
                    console.error("Logspot - event parameter is required");
                    return [2 /*return*/];
                }
                _c.label = 1;
            case 1:
                _c.trys.push([1, 5, , 6]);
                payloadToSend = {
                    name: payload.event,
                    channel: payload.channel,
                    message: payload.message,
                    notify: payload.notify,
                    user_id: payload.userId,
                    metadata: (_a = payload.metadata) !== null && _a !== void 0 ? _a : {},
                    hostname: payload.hostname,
                    url: payload.url,
                    referrer: ((_b = payload.referrer) === null || _b === void 0 ? void 0 : _b.length) ? payload.referrer : null,
                    language: payload.language,
                    screen: payload.screen,
                };
                if (!config.eventMapper) return [3 /*break*/, 3];
                return [4 /*yield*/, config.eventMapper(payloadToSend)];
            case 2:
                payloadToSend = _c.sent();
                _c.label = 3;
            case 3: return [4 /*yield*/, fetch(config.externalApiUrl ? config.externalApiUrl : "".concat(API_URL, "/i"), {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "x-logspot-pk": config.publicKey,
                    },
                    mode: "cors",
                    body: JSON.stringify(payloadToSend),
                })];
            case 4:
                _c.sent();
                return [3 /*break*/, 6];
            case 5:
                err_1 = _c.sent();
                console.error("Logspot - could not track event");
                return [3 /*break*/, 6];
            case 6: return [2 /*return*/];
        }
    });
}); };
exports.trackEvent = trackEvent;
